export default {
  de: [
    {
      title: 'Daten',
      text: (
        <>
          Rundungsdifferenzen wurden in der jeweiligen Gruppe korrigiert, wo der
          Ausgleich den geringsten relativen Fehler verursacht.
        </>
      ),
      listItem: [
        {
          title: 'Alter',
          text: 'Ständige Wohnbevölkerung nach Alter (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Steuerpflichtiges Vermögen',
          text: 'Vermögen der natürlichen Personen (2019) – In den Steuererklärungen per 31. Dezember 2019 ausgewiesenes Reinvermögen (Aktiven abzüglich Passiven, vor Berücksichtigung der Sozialabzüge), Quelle: Eidgenössische Steuerverwaltung (ESTV)',
        },
        {
          title: 'Armut',
          text: 'Armutsquote (2020) – Die Armutsgrenze betrug 2020 durchschnittlich 2279 Franken pro Monat für eine Einzelperson und 3963 Franken pro Monat für einen Haushalt mit zwei Erwachsenen und zwei Kindern unter 14 Jahren; Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Kantone',
          text: 'Struktur der ständigen Wohnbevölkerung nach Kanton (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Nationalität',
          text: 'Ständige ausländische Wohnbevölkerung nach Staatsangehörigkeit (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Zivilstand',
          text: 'Ständige Wohnbevölkerung nach Zivilstand (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Konfession',
          text: 'Religionszugehörigkeit ständige Wohnbevölkerung (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Wahlverhalten 2019',
          text: 'Wahlbeteiligung, Stärke der Parteien & ständige Wohnbevölkerung, Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Körpergewicht',
          text: 'Body Mass Index 2017, Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Sportliche Aktivität',
          text: 'Schweizerische Gesundheitsbefragung (2017), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Ernährung',
          text: 'MACH-Konsumentenumfrage (2022), Quelle: Swissveg.ch',
        },
        {
          title: 'Alkoholkonsum',
          text: 'Schweizerische Gesundheitsbefragung (2017), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Medikamentenkonsum',
          text: 'Schweizerische Gesundheitsbefragung (2017), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Haustiere',
          text: 'Studie Homegate.ch (2019), Quelle: Homegate.ch',
        },
        {
          title: 'Mieter oder Eigentümer',
          text: 'Wohnverhältnisse nach Bewohnertyp (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Höchste abgeschlossene Ausbildung',
          text: 'Höchste abgeschlossene Ausbildung in der Schweiz (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Arbeitssituation',
          text: 'Erwerbsstatus Jahreswert (2021), Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Pendelverhalten',
          text: 'Erwerbstätige Pendler/innen nach Hauptverkehrsmitteln (2021); Quelle: Bundesamt für Statistik',
        },
        {
          title: 'Pendelzeit',
          text: 'Erwerbstätige Pendler/innen nach Hauptverkehrsmitteln (2021), Quelle: Bundesamt für Statistik',
        },
      ],
    },
  ],
  fr: [
    {
      title: 'Données',
      text: (
        <>
          Les différences liées aux arrondissements ont été corrigées dans le
          groupe concerné, où la compensation entraîne l'erreur relative la plus
          faible.
        </>
      ),
      listItem: [
        {
          title: "Âge",
          text: 'Population résidente permanente selon l’âge (2021), Source: Office fédéral de la statistique',
        },
        {
          title: 'Fortune imposable',
          text: 'Fortune des personnes physiques (2019) – Fortune nette figurant dans les déclarations fiscales au 31 décembre 2019 (actifs moins passifs, avant prise en compte des déductions sociales), Source: Administration fédérale des contributions (AFC)',
        },
        {
          title: 'Pauvreté',
          text: "Taux de pauvreté (2020) - En 2020, le seuil de pauvreté s'élevait en moyenne à 2279 francs par mois pour une personne seule et à 3963 francs par mois pour un ménage composé de deux adultes et de deux enfants de moins de 14 ans.; Source: Office fédéral de la statistique",
        },
        {
          title: 'Cantons',
          text: 'Structure de la population résidente permanente par canton (2021), source: Office fédéral de la statistique',
        },
        {
          title: 'Nationalités',
          text: 'Population résidante permanente étrangère par nationalité (2021), Source: Office fédéral de la statistique',
        },
        {
          title: 'État civil',
          text: 'Population résidente permanente selon l’état civil (2021), Source: Office fédéral de la statistique',
        },
        {
          title: 'Confession',
          text: 'Appartenance religieuse de la population résidente permanente (2021), Source: Office fédéral de la statistique',
        },
        {
          title: 'Comportement électoral en 2019',
          text: 'Participation électorale, force des partis & population résidente permanente, Source: Office fédéral de la statistique',
        },
        {
          title: 'Masse corporelle',
          text: 'Indice de masse corporelle 2017, Source: Office fédéral de la statistique',
        },
        {
          title: 'Activité physique',
          text: 'Enquête suisse sur la santé (2017), Source: Office fédéral de la statistique',
        },
        {
          title: 'Alimentation',
          text: 'Enquête MACH auprès des consommateurs et consommatrices (2022), Source: Swissveg.ch',
        },
        {
          title: "Consommation d'alcool",
          text: 'Enquête suisse sur la santé (2017), Source: Office fédéral de la statistique',
        },
        {
          title: 'Consommation de médicaments',
          text: 'Enquête suisse sur la santé (2017), Source: Office fédéral de la statistique',
        },
        {
          title: 'Animaux domestiques',
          text: 'Étude Homegate.ch (2019), Source: Homegate.ch',
        },
        {
          title: 'Locataires ou propriétaires',
          text: "Conditions de logement par type d'occupant (2021), Source: Office fédéral de la statistique",
        },
        {
          title: 'Formation la plus élevée achevée',
          text: 'Formation la plus élevée achevée en Suisse (2021), Source: Office fédéral de la statistique',
        },
        {
          title: 'Situation professionnelle',
          text: "Statut d'activité valeur annuelle (2021), Source: Office fédéral de la statistique",
        },
        {
          title: 'Pendularité',
          text: 'Pendulaires actifs selon le moyen de transport principal (2021); Source: Office fédéral de la statistique',
        },
        {
          title: 'Durée du trajet domicile-travail',
          text: 'Pendulaires actifs selon le moyen de transport principal (2021), Source: Office fédéral de la statistique',
        },
      ],
    },
  ],
}
